<template>
  <v-card min-height="550">
    <v-row width="100%">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.animalID')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.UniqueIdAnimal')}} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.animalNumber
                      ? currentAnimal.animalNumber
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.plasticTagNumber')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.numberAnimalTag')}} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.tagType == 'plastic'
                      ? currentAnimal.tagNumber
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.rFTagNumber')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('geneticsAndBreeding.selectTraitDescription')}} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.RFTagNumber
                      ? currentAnimal.RFTagNumber
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-no-wrap"
                  >{{$t('animal.govtRegNumb')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.govtRegistrationNumber')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.registrationNumber
                      ? currentAnimal.registrationNumber
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.trackingNumber')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span> {{$t('animal.numberAssignedAnimalIsRemoved')}} </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.trackingNumber
                      ? currentAnimal.trackingNumber
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.registrationDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.dateOfAnimalRegistration')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.createdAt
                      ? currentAnimal.createdAt
                      : $t('notSpecified') | formatDate
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.brand')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.brand ? currentAnimal.brand : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.tatto')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.tattoOnAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.tattoo
                      ? currentAnimal.tattoo
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.hornStatus')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.whetherTheAnimalIsDehorned')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.hornStatus
                      ? currentAnimal.hornStatus
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    console.log("identifi");
  },
  computed: {
    ...mapGetters(["currentAnimal"]),
  },
};
</script>